import { H as HeadingsDropDownPanel } from './HeadingPanel-e286797a.js';
import 'react';
import 'prop-types';
import 'wix-rich-content-common';
import 'classnames';
import './constants.js';
import 'wix-rich-content-plugin-commons';

const Modals = {
  HEADINGS: "HEADINGS"
};
const ModalsMap = {
  [Modals.HEADINGS]: HeadingsDropDownPanel
};

export { Modals, ModalsMap };
//# sourceMappingURL=modals.js.map
